import MoreVert from "@mui/icons-material/MoreVert";
import { IconButton, Menu, MenuItem, Tooltip } from "@mui/material";
import { useChemicalInventoryExport } from "components/ChemicalInventoryExportProvider";
import { useState } from "react";

export function FacilityInventoryActionsMenu({
  facilityId,
  facilityName,
}: {
  facilityId?: string;
  facilityName?: string;
}) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const { tenantId, isExporting, openExport } = useChemicalInventoryExport();

  return (
    <>
      <Tooltip title="More actions">
        <IconButton
          size="small"
          aria-label="More actions"
          disabled={!tenantId || !facilityId || isExporting}
          loading={isExporting}
          onClick={(event) => setAnchorEl(event.currentTarget)}
        >
          <MoreVert fontSize="small" />
        </IconButton>
      </Tooltip>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        <MenuItem
          disabled={isExporting}
          onClick={() => {
            setAnchorEl(null);
            openExport({ facilityId, facilityName });
          }}
        >
          Export facility inventory
        </MenuItem>
      </Menu>
    </>
  );
}
